export default "__VITE_ASSET__0befd6ee__"